import { MediaObjectModel } from './media-object.model';

export class UserModel {
  static ROLES = {
    ROLE_USER: {
      CODE: 'ROLE_USER',
      DESC: 'Usuário',
    },
  };

  '@id': number;
  id: number;
  name: string;
  document: string;
  fantasyName: string;
  email: string;
  password?: string;
  retypedPassword?: string;
  newPassword?: string;
  newRetypedPassword?: string;
  oldPassword?: string;
  roles: string[];
  enabled?: boolean;
  suspended?: boolean;
  avatar?: MediaObjectModel;
  phone?: string;
  zipCode?: string;
  address?: string;
  addressNumber?: string;
  addressAdditional?: string;
  district?: string;
  city?: any;
  state?: any;
  createdAt?: string;
  confirmationToken?: string;
  userMediaDocuments?: UserMediaDocumentsModel[];
  deletedAt?: string;
}

export class UserMediaDocumentsModel {
  id: string;
  document: string;
  name: string;
}
